// Gelber Hinweis „Entwurf gefunden" mit Wiederherstellen / Verwerfen (siehe hooks/useEntwurf.ts)
export function EntwurfBanner({ at, zusammenfassung, onWiederherstellen, onVerwerfen, className = '' }: {
  at: string;
  zusammenfassung?: string;
  onWiederherstellen: () => void;
  onVerwerfen: () => void;
  className?: string;
}) {
  const wann = new Date(at).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
  return (
    <div className={`rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900 flex items-center justify-between gap-3 flex-wrap ${className}`}>
      <span>
        📝 <b>Entwurf vom {wann} Uhr gefunden</b>{zusammenfassung ? ` (${zusammenfassung})` : ''}
        <span className="block text-xs opacity-80">Automatisches Sichern ist pausiert, bis du wählst.</span>
      </span>
      <span className="flex gap-2">
        <button type="button" onClick={onWiederherstellen}
                className="bg-amber-500 text-white rounded-lg px-3 py-1.5 text-sm font-medium hover:opacity-90">Wiederherstellen</button>
        <button type="button" onClick={onVerwerfen}
                className="border border-amber-400 text-amber-900 rounded-lg px-3 py-1.5 text-sm hover:bg-amber-100">Verwerfen</button>
      </span>
    </div>
  );
}
